import { NavLink, Stack } from '@mantine/core';
import {
  IconDashboard,
  IconBuilding,
  IconCoin,
  IconAutomation,
  IconChartBar,
  IconHeartRateMonitor,
  IconTopologyStarRing3,
  IconShieldCheck,
  IconPrinter,
  IconSettings,
    IconBrandGoogle,
  IconUserQuestion,
} from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'Dashboard', icon: IconDashboard, path: '/' },
  { label: 'Demo-Anfragen', icon: IconUserQuestion, path: '/demos' },
  { label: 'Unternehmen', icon: IconBuilding, path: '/companies' },
  { label: 'Token-Aktionen', icon: IconCoin, path: '/tokens' },
  { label: 'Automatisierung', icon: IconAutomation, path: '/automation' },
  { label: 'Moderation', icon: IconShieldCheck, path: '/moderation' },
  { label: 'Umsätze', icon: IconChartBar, path: '/revenue' },
  { label: 'Cockpit', icon: IconHeartRateMonitor, path: '/cockpit' },
  { label: 'Architektur', icon: IconTopologyStarRing3, path: '/architecture' },
  { label: 'Website Druck', icon: IconPrinter, path: '/website-print' },
  { label: 'Einstellungen', icon: IconSettings, path: '/settings' },
  { label: 'Google Ads Auditor', icon: IconBrandGoogle, path: '/google-ads-auditor' },
];

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Stack gap={4}>
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          label={item.label}
          leftSection={<item.icon size={20} stroke={1.5} />}
          active={
            item.path === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.path)
          }
          onClick={() => navigate(item.path)}
        />
      ))}
    </Stack>
  );
}
